module.exports = __webpack_public_path__ + "static/img/user5.f214702.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user5.jpg
// module id = +pS5
// module chunks = 23